import React from 'react';
import { connect, DispatchProp } from 'react-redux';

import {
    rulesEngineSelectors,
    Skill,
    SkillUtils,
    ValueLookup,
    CharacterTheme,
    RuleData,
} from '@dndbeyond/character-rules-engine/es';
import { IRollContext } from '@dndbeyond/dice';

import { sidebarActions } from '../../../../Shared/actions';
import { appEnvSelectors, characterRollContextSelectors } from '../../../../Shared/selectors';
import { PaneComponentEnum, PaneIdentifierUtils } from '../../../../Shared/utils';
import MobileDivider from '../../../components/MobileDivider';
import Skills from '../../../components/Skills';
import SubsectionMobile from '../../../components/SubsectionMobile';
import { SheetAppState } from '../../../typings';

interface Props extends DispatchProp {
    skills: Array<Skill>;
    customSkills: Array<Skill>;
    valueLookup: ValueLookup;
    theme: CharacterTheme;
    diceEnabled: boolean;
    ruleData: RuleData;
    characterRollContext: IRollContext;
}
class SkillsBox extends React.PureComponent<Props> {
    handleManageShow = (): void => {
        const { dispatch } = this.props;

        dispatch(sidebarActions.paneHistoryStart(PaneComponentEnum.SKILLS));
    };

    handleCustomSkillClick = (skill: Skill): void => {
        const { dispatch } = this.props;

        dispatch(
            sidebarActions.paneHistoryStart(
                PaneComponentEnum.CUSTOM_SKILL,
                PaneIdentifierUtils.generateCustomSkill(SkillUtils.getId(skill)),
            ),
        );
    };

    handleEmptyClick = (): void => {
        this.handleManageShow();
    };

    handleSkillClick = (skill: Skill): void => {
        const { dispatch } = this.props;

        dispatch(
            sidebarActions.paneHistoryStart(
                PaneComponentEnum.SKILL,
                PaneIdentifierUtils.generateSkill(SkillUtils.getId(skill)),
            ),
        );
    };

    render() {
        const { skills, valueLookup, customSkills, theme, diceEnabled, ruleData, characterRollContext } = this.props;

        return (
            <SubsectionMobile name="Skills">
                <div className={`ct-skills-mobile ${theme.isDarkMode ? 'ct-skills-mobile--dark-mode' : ''}`}>
                    <MobileDivider label="Skills" onClick={this.handleManageShow} theme={theme} />
                    <Skills
                        skills={skills}
                        customSkills={customSkills}
                        valueLookup={valueLookup}
                        onCustomSkillClick={this.handleCustomSkillClick}
                        onSkillClick={this.handleSkillClick}
                        onEmptyClick={this.handleEmptyClick}
                        diceEnabled={diceEnabled}
                        ruleData={ruleData}
                        theme={theme}
                        rollContext={characterRollContext}
                    />
                    <MobileDivider isEnd={true} theme={theme} />
                </div>
            </SubsectionMobile>
        );
    }
}

function mapStateToProps(state: SheetAppState) {
    return {
        skills: rulesEngineSelectors.getSkills(state),
        valueLookup: rulesEngineSelectors.getCharacterValueLookup(state),
        customSkills: rulesEngineSelectors.getCustomSkills(state),
        theme: rulesEngineSelectors.getCharacterTheme(state),
        diceEnabled: appEnvSelectors.getDiceEnabled(state),
        ruleData: rulesEngineSelectors.getRuleData(state),
        characterRollContext: characterRollContextSelectors.getCharacterRollContext(state),
    };
}

export default connect(mapStateToProps)(SkillsBox);
